import { createMovieClip } from "../../../common/functions/Functions_General";
import { GameData } from "../gamestate/gameData";

//Create  a gameTile that contain all the animatiion within a movieclip and play in loop only the reqired animation.

export class GameTile {
  private parent: PIXI.Container = new PIXI.Container();
  private symbolContainer: PIXI.Container = new PIXI.Container();
  private sizeX: number;
  private sizeY: number;
  private tileImgName: Array<string>;
  private tileImgNamePast: Array<string>;
  private tileImgStart: Array<number>;
  private tileImgEnd: Array<number>;
  private tileStartFrame: Array<number>;
  private framesPerAnimation: Array<number>;
  private totalFrames: number;
  private extraSpinStyle: PIXI.TextStyle;
  private activeGameData: GameData;
  private addSpinText: PIXI.Text;
  private addSpinTextTweenIn: PIXI.tween.Tween;
  private activeIndex: number;
  private scaleTween: PIXI.tween.Tween;

  // private bgAddShockWave: PIXI.extras.AnimatedSprite; //on EXPAND--shockwaveon expand
  private bonusSymbolSelectedBG: PIXI.extras.AnimatedSprite;
  private bookSymbolBG: PIXI.extras.AnimatedSprite; //---pharaon symbol BG

  private pharaonSymbolBG: PIXI.extras.AnimatedSprite; //---pharaon symbol BG
  private symbolEyeBG: PIXI.extras.AnimatedSprite; //---pharaon symbol BG
  private symbolCrossBG: PIXI.extras.AnimatedSprite; //---pharaon symbol BG
  private symbolInsectBG: PIXI.extras.AnimatedSprite; //---pharaon symbol BG

  private movieClip: PIXI.extras.AnimatedSprite;

  private movieClipFramesPast: Array<PIXI.Texture>;
  private movieClipFramesPresent: Array<PIXI.Texture>;
  private defaultScale: number;
  private presentSymbolActive: boolean = false;

  constructor(parent: PIXI.Container, activeGameData: GameData) {
    parent.addChild(this.parent);
    this.activeGameData = activeGameData;
    this.sizeX = this.activeGameData.cardsize * 1;
    this.sizeY = this.activeGameData.cardsize * 1;
    this.parent.addChild(this.symbolContainer);

    this.movieClip; //contains all the animations possible on single clip;

    this.activeGameData = activeGameData;
    this.tileImgName = this.activeGameData.tileImgName;
    this.tileImgNamePast = this.activeGameData.tileImgNamePast;

    this.tileImgStart = this.activeGameData.tileImgStart;
    this.tileImgEnd = this.activeGameData.tileImgEnd;
    this.tileStartFrame = [];
    this.framesPerAnimation = [];

    this.totalFrames = 0; //re-defined later

    //Bonus game +1 display
    this.extraSpinStyle = new PIXI.TextStyle({
      fontFamily: this.activeGameData.gameTextStyle.gameFont,
      fontSize: 50,
      fill: "#ffffff",
      fontWeight: "bold",
      lineHeight: 60,
      align: "center",

      dropShadow: true,
      dropShadowColor: "#000000",
      dropShadowBlur: 10,
      dropShadowAngle: Math.PI / 6,
      dropShadowDistance: 0,
    });
    this.addSpinText = new PIXI.Text(
      "+1\n " + this.activeGameData.gameTextGeneral.spin,
      this.extraSpinStyle
    );
    this.addSpinTextTweenIn;

    this.createMovieClip();

    // this.createMovieClipParentTiles(true)
    //GENERATE GAME DECK WHEN GAME IS OPENED ,

    if (this.activeGameData.diceCounter < 5) {
      this.activeIndex = Math.floor(Math.random() * 3); //--initial DECKS
    } else if (this.activeGameData.diceCounter < 10) {
      this.activeIndex = Math.floor(Math.random() * 3) + 3; //--initial DECKS
    } else {
      this.activeIndex = Math.floor(Math.random() * 6); //--initial DECKS
    }

    // console.log(this.activeIndex);
    this.activeGameData.diceCounter++;
    // this.activeIndex=9
  }

  private createMovieClip = (): void => {
    let tilesToUse = this.tileImgName;

    // this.movieClip=null;

    this.movieClipFramesPresent = [];
    let tileindex = 0;
    let currentTileImage = tilesToUse[tileindex];

    for (var i = 0; i < tilesToUse.length; i++) {
      for (var j = this.tileImgStart[i]; j < this.tileImgEnd[i]; j++) {
        if (j < 10) {
          this.movieClipFramesPresent.push(
            PIXI.Texture.fromFrame(currentTileImage + "_0000" + j + ".png")
          );
        } else {
          this.movieClipFramesPresent.push(
            PIXI.Texture.fromFrame(currentTileImage + "_000" + j + ".png")
          );
        }
      }

      tileindex++;

      currentTileImage = tilesToUse[tileindex];
    }
    //add blur frames added to the end
    for (var i = 0; i < this.activeGameData.tileImgNameBlurred.length; i++) {
      let framename = this.activeGameData.tileImgNameBlurred[i] + ".png";
      this.movieClipFramesPresent.push(PIXI.Texture.fromFrame(framename));
      // console.log(framename)
    }

    this.movieClip = new PIXI.extras.AnimatedSprite(
      this.movieClipFramesPresent
    );
    this.movieClip.animationSpeed = 0.35; //diceSpeed

    this.movieClip.height = this.sizeY;
    this.movieClip.width = this.sizeX;
    this.defaultScale = this.movieClip.scale.x;
    this.movieClip.anchor.set(0.5);

    this.movieClip.x = this.movieClip.width / 2;
    this.movieClip.y = this.movieClip.height / 2;

    //--create new movieClip for past
    let tilesToUsePast = this.tileImgNamePast;

    // this.movieClip=null;
    if (this.movieClip != undefined && this.movieClip.parent != null) {
      // console.log(this.movieClip.parent);
    }
    this.movieClipFramesPast = [];
    tileindex = 0;
    currentTileImage = tilesToUsePast[tileindex];

    for (var i = 0; i < tilesToUsePast.length; i++) {
      for (var j = this.tileImgStart[i]; j < this.tileImgEnd[i]; j++) {
        if (j < 10) {
          this.movieClipFramesPast.push(
            PIXI.Texture.fromFrame(currentTileImage + "_0000" + j + ".png")
          );
        } else {
          this.movieClipFramesPast.push(
            PIXI.Texture.fromFrame(currentTileImage + "_000" + j + ".png")
          );
        }
      }

      tileindex++;

      currentTileImage = tilesToUsePast[tileindex];
    }
    //add blur frames added to the end
    for (var i = 0; i < this.activeGameData.tileImgNameBlurred.length; i++) {
      let framename = this.activeGameData.tileImgNameBlurred[i] + ".png";
      this.movieClipFramesPast.push(PIXI.Texture.fromFrame(framename));
      // console.log(framename)
    }

    this.bookSymbolBG = createMovieClip("frameBoook", 0, 39);
    this.bookSymbolBG.anchor.set(0.5);
    this.bookSymbolBG.width = this.movieClip.width;
    this.bookSymbolBG.height = this.movieClip.height;
    this.bookSymbolBG.x = this.movieClip.width / 2;
    this.bookSymbolBG.y = this.movieClip.width / 2;
    this.bookSymbolBG.animationSpeed = 0.35;
    this.symbolContainer.addChild(this.bookSymbolBG);
    this.bookSymbolBG.alpha = 0;

    this.pharaonSymbolBG = createMovieClip("Frame0", 0, 5);
    this.pharaonSymbolBG.anchor.set(0.5);
    this.pharaonSymbolBG.width = this.movieClip.width;
    this.pharaonSymbolBG.height = this.movieClip.height;
    this.pharaonSymbolBG.x = this.movieClip.width / 2;
    this.pharaonSymbolBG.y = this.movieClip.width / 2;
    this.pharaonSymbolBG.animationSpeed = 0.35;
    this.symbolContainer.addChild(this.pharaonSymbolBG);
    this.pharaonSymbolBG.alpha = 0;

    this.symbolEyeBG = createMovieClip("Frame1", 0, 5);
    this.symbolEyeBG.anchor.set(0.5);
    this.symbolEyeBG.width = this.movieClip.width;
    this.symbolEyeBG.height = this.movieClip.height;
    this.symbolEyeBG.x = this.movieClip.width / 2;
    this.symbolEyeBG.y = this.movieClip.width / 2;
    this.symbolEyeBG.animationSpeed = 0.35;
    this.symbolContainer.addChild(this.symbolEyeBG);
    this.symbolEyeBG.alpha = 0;

    this.symbolCrossBG = createMovieClip("Frame2", 0, 5);
    this.symbolCrossBG.anchor.set(0.5);
    this.symbolCrossBG.width = this.movieClip.width;
    this.symbolCrossBG.height = this.movieClip.height;
    this.symbolCrossBG.x = this.movieClip.width / 2;
    this.symbolCrossBG.y = this.movieClip.width / 2;
    this.symbolCrossBG.animationSpeed = 0.35;
    this.symbolContainer.addChild(this.symbolCrossBG);
    this.symbolCrossBG.alpha = 0;

    this.symbolInsectBG = createMovieClip("Frame3", 0, 5);
    this.symbolInsectBG.anchor.set(0.5);
    this.symbolInsectBG.width = this.movieClip.width;
    this.symbolInsectBG.height = this.movieClip.height;
    this.symbolInsectBG.x = this.movieClip.width / 2;
    this.symbolInsectBG.y = this.movieClip.width / 2;
    this.symbolInsectBG.animationSpeed = 0.35;
    this.symbolContainer.addChild(this.symbolInsectBG);
    this.symbolInsectBG.alpha = 0;

    this.bonusSymbolSelectedBG = createMovieClip("specialSymbolBG", 0, 20);
    this.bonusSymbolSelectedBG.anchor.set(0.5);
    this.bonusSymbolSelectedBG.width = this.movieClip.width;
    this.bonusSymbolSelectedBG.height = this.movieClip.height;
    this.bonusSymbolSelectedBG.x = this.movieClip.width / 2;
    this.bonusSymbolSelectedBG.y = this.movieClip.width / 2;
    this.bonusSymbolSelectedBG.animationSpeed = 0.35;
    this.symbolContainer.addChild(this.bonusSymbolSelectedBG);
    this.bonusSymbolSelectedBG.alpha = 0;

    // this.bgAddShockWave = createMovieClip("expandBg", 0, 24);

    // this.bgAddShockWave.anchor.set(0.5);
    // this.bgAddShockWave.width = this.movieClip.width;
    // this.bgAddShockWave.height = this.movieClip.height;

    // // this.bgAddShockWave.scale.set(2);
    // this.bgAddShockWave.loop=false;
    // // this.bgAddShockWave.gotoAndPlay(0)

    // this.bgAddShockWave.x = this.movieClip.width / 2;
    // this.bgAddShockWave.y = this.movieClip.width / 2;
    // this.bgAddShockWave.animationSpeed = 0.5;
    // this.bgAddShockWave.blendMode = PIXI.BLEND_MODES.ADD;
    // this.symbolContainer.addChild(this.bgAddShockWave);
    // // this.bgAddShockWave.gotoAndPlay(0);
    // this.bgAddShockWave.loop = false;

    this.symbolContainer.addChild(this.movieClip);
    // this.symbolContainer.addChild(this.pastMovieClip);

    //extra spin position
    this.symbolContainer.addChild(this.addSpinText);
    this.addSpinText.anchor.set(0.5);
    this.addSpinText.position.set(
      this.symbolContainer.width / 2 - this.addSpinText.width / 3,
      this.symbolContainer.height / 2 - this.addSpinText.height / 3
    );

    this.addSpinText.alpha = 0;
    this.getStartingFrame();

    this.addSpinTextTweenIn = PIXI.tweenManager.createTween(this.addSpinText);
    this.addSpinTextTweenIn
      .from({ alpha: 0, scale: { x: 3, y: 3 } })
      .to({ alpha: 1, scale: { x: 1, y: 1 } });
    this.addSpinTextTweenIn.time = 1500; //get speed from winline animation
    this.addSpinTextTweenIn.easing = PIXI.tween.Easing.outBack();
    this.addSpinTextTweenIn.loop = true;
    // this.addSpinTextTweenIn.start();

    this.scaleTween = PIXI.tweenManager.createTween(this.movieClip);
    this.scaleTween
      .from({
        alpha: 1,
        scale: { x: 0, y: 0 },
        rotation: 0,
      })
      .to({
        alpha: 1,
        scale: { x: this.defaultScale, y: this.defaultScale },
        rotation: 0,
      });
    this.scaleTween.time = 1000;
    this.scaleTween.easing = PIXI.tween.Easing.outElastic();
    this.scaleTween.loop = false;
    this.scaleTween.pingPong = false;
    this.setWinTweenActive(false);
  };

  public setSymbolPresent = (bool: boolean): void => {
    if (bool && this.presentSymbolActive == false) {
      this.movieClip.textures = this.movieClipFramesPresent;
      this.presentSymbolActive = true;
    } else if (this.presentSymbolActive && bool == false) {
      this.movieClip.textures = this.movieClipFramesPast;
      this.presentSymbolActive = false;
    }
    this.setCurrentFrame(this.activeIndex);
  };
  public clearBonusBG = (): void => {
    this.enableBonusSymbolBG(false);
  };
  private checkTHeBonusBG = (): void => {
    let isBonus =
      this.activeGameData.GameContext().bonusGameResult != undefined;
    let isBonusMode = this.activeGameData.gameMode == "bonusGame";
    if (isBonus && isBonusMode) {
      let bonusSymbolSelected =
        this.activeGameData.GameContext().expandingSymbol - 1;
      if (this.activeIndex == bonusSymbolSelected) {
        this.enableBonusSymbolBG(true);
      } else {
        this.enableBonusSymbolBG(false);
      }
    } else {
      this.enableBonusSymbolBG(false);
    }
  };
  private checkSpecialSymbolsBG = (): void => {
    let pharaonSymbolIndex = 8; //---index for each symbol
    if (this.activeIndex == pharaonSymbolIndex) {
      this.pharaonSymbolBG.alpha = 1;
    } else {
      this.pharaonSymbolBG.alpha = 0;
    }
    //--

    let symbolEyeIndex = 7; //---index for each symbol
    if (this.activeIndex == symbolEyeIndex) {
      this.symbolEyeBG.alpha = 1;
    } else {
      this.symbolEyeBG.alpha = 0;
    }

    //--
    let symbolCrossIndex = 6; //---index for each symbol
    if (this.activeIndex == symbolCrossIndex) {
      this.symbolCrossBG.alpha = 1;
    } else {
      this.symbolCrossBG.alpha = 0;
    }

    //--
    let symbolInsectIndex = 5; //---index for each symbol
    if (this.activeIndex == symbolInsectIndex) {
      this.symbolInsectBG.alpha = 1;
    } else {
      this.symbolInsectBG.alpha = 0;
    }

    let symbolIBookIndex = 9; //---index for each symbol
    if (this.activeIndex == symbolIBookIndex) {
      this.bookSymbolBG.alpha = 1;
      this.bookSymbolBG.gotoAndPlay(0);
    } else {
      this.bookSymbolBG.alpha = 0;
      this.bookSymbolBG.gotoAndStop(0);
    }

    //   symbolEyeBG: symbolCrossBG: symbolInsectBG
  };

  private enableBonusSymbolBG = (bool: boolean): void => {
    this.bonusSymbolSelectedBG.alpha = bool ? 1 : 0;
    if (bool) {
      this.bonusSymbolSelectedBG.gotoAndPlay(0);
      this.pharaonSymbolBG.alpha = 0;
      this.symbolInsectBG.alpha = 0;
      this.symbolEyeBG.alpha = 0;
      this.symbolCrossBG.alpha = 0;
    } else if (this.bonusSymbolSelectedBG.playing) {
      this.bonusSymbolSelectedBG.stop();
    }
  };

  // private enableSpecialSymbolBG=(bool:boolean):void=>
  // {
  //   // console.log('BOOL', bool)
  //   this.pharaonSymbolBG.alpha=bool?1:0;;
  // }
  public playScaleTween = (): void => {
    this.scaleTween.stop();
    this.scaleTween.reset();
    this.scaleTween.start();
    // this.activeGameData.expandAnimSound.play("win");
    // this.bgAddShockWave.gotoAndPlay(0);
  };
  // extraSpinParent(parent:PIXI.Container)
  // {
  // 	parent.addChild(this.addSpinText)
  // }

  public setCurrentFrame = (imageIndex: number): void => {
    // console.log(imageIndex)
    // if(imageIndex==0)
    // {console.log("here",imageIndex,this.activeIndex.)}

    this.movieClip.onFrameChange = null;
    this.activeIndex = imageIndex;
    let startFrame = this.tileStartFrame[imageIndex]; // +8;//offset
    this.movieClip.gotoAndStop(startFrame); //--bc the
    //---check the bonus bg
    //-check the symbol default backgrounds
    this.checkSpecialSymbolsBG();
    this.checkTHeBonusBG();
    this.setWinTweenActive(false);
  };

  public setCurrentFrameBlurred = (index: number): void => {
    // this.setBlackenTint(true);
    this.movieClip.onFrameChange = null;
    this.activeIndex = index;
    let startFrame =
      this.movieClip.totalFrames -
      (this.activeGameData.tileImgNameBlurred.length - index);
    // let startFrame=this.tileStartFrame[index]+10;
    this.movieClip.gotoAndStop(startFrame); //--bc the
    this.setWinTweenActive(false);
  };

  public setBlackenTint = (bool: boolean): void => {
    // console.log(bool)
    this.movieClip.tint = bool ? 0x666666 : 0xffffff;
    this.pharaonSymbolBG.tint = bool ? 0x666666 : 0xffffff;
    this.symbolEyeBG.tint = bool ? 0x666666 : 0xffffff;
    this.symbolCrossBG.tint = bool ? 0x666666 : 0xffffff;
    this.symbolInsectBG.tint = bool ? 0x666666 : 0xffffff;
    this.bookSymbolBG.tint = bool ? 0x666666 : 0xffffff;
    this.bonusSymbolSelectedBG.tint = bool ? 0x666666 : 0xffffff;
  };

  public setUsedGiftBoxTint = (bool: boolean): void => {
    // console.log(bool)
    this.movieClip.tint = bool ? 0x555555 : 0xffffff;

    // this.movieClip.alpha = bool ? 1 : 1;
  };

  public setLoopAndPlay = (): void => {
    if (!this.movieClip.playing) {
      this.movieClip.onFrameChange = null;

      let startFrame = this.tileStartFrame[this.activeIndex];
      let endFrame = startFrame + this.framesPerAnimation[this.activeIndex];

      startFrame = this.tileStartFrame[this.activeIndex]; //
      // this.movieClip.gotoAndPlay(startFrame);
      this.movieClip.play();
      this.setWinTweenActive(true);
      this.movieClip.onFrameChange = function(
        endFrame: number,
        startFrame: number
      ) {
        // console.log(this.currentFrame,startFrame,endFrame)
        if (this.currentFrame >= endFrame) {
          this.gotoAndPlay(startFrame);

          // console.log('ANIMATE')
        }
      }.bind(this.movieClip, endFrame, startFrame);
    } else {
      // console.log("movieclip active")
    }
  };

  public setAnimationLoopActive = (bool: boolean): void => {
    if (bool) {
      this.setLoopAndPlay();
    } else {
      this.setCurrentFrame(this.activeIndex);

      //
    }
  };

  private getStartingFrame = (): void => {
    this.deltaFrames();
    for (var i = 0; i < this.tileImgStart.length; i++) {
      this.tileStartFrame[i] = this.totalFrames;
      this.totalFrames += this.framesPerAnimation[i];
    }
  };

  private deltaFrames = (): void => {
    for (var i = 0; i < this.tileImgStart.length; i++) {
      this.framesPerAnimation[i] = this.tileImgEnd[i] - this.tileImgStart[i];
    }
  };

  public setExtraSpinTweenReset = (): void => {
    this.addSpinTextTweenIn.reset();
    this.addSpinTextTweenIn.stop();
    this.addSpinText.alpha = 0;
  };

  public getActiveIndex = (): number => {
    return this.activeIndex;
  };

  public setContainerPosition(posX: number, posY: number) {
    this.symbolContainer.position.set(posX, posY);
  }

  public setWinTweenActive = (bool: boolean): void => {
    if (bool) {
    } else {
      this.movieClip.scale.set(this.defaultScale);
      this.movieClip.rotation = 0;
    }
  };
}
